export async function generateHashValue(
    username: string,
    score: number,
    leaderboard_secret: string
): Promise<string> {
    const toHash = `${username}${score}${leaderboard_secret}`;

    // Encode the string as UTF-8
    const encoder = new TextEncoder();
    const data = encoder.encode(toHash);

    // Hash the data using SHA-256
    const hashBuffer = await crypto.subtle.digest("SHA-256", data);

    // Convert the hash to a hex string
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray.map(b => b.toString(16).padStart(2, "0")).join("");

    return hashHex;
}